import { Box, Table, Tag, Text } from '@factorialco/deprecated-design-system'
import { BookkeepersManagementIncidencePayrollIntegrationStatus } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import payrollIntegrationStatusTagColor from 'modules/bookkeepers/lib/payrollIntegrationStatusTagColor'

interface Props {
  payrollIntegrationStatus?: BookkeepersManagementIncidencePayrollIntegrationStatus
  showIncidencePayrollIntegrationStatus: boolean
}

const PayrollIntegrationStatus = ({
  payrollIntegrationStatus,
  showIncidencePayrollIntegrationStatus,
}: Props) => {
  const isBookkeeperView = useBookkeeperView()
  const payrollIntegrationStatusTranlsation = () => {
    if (!payrollIntegrationStatus) {
      return i18n.t('bookkeepers.incidence.incidence_payroll_integration_status.undefined')
    }

    switch (payrollIntegrationStatus.status) {
      case 'unavailable': {
        return i18n.t('bookkeepers.incidence.incidence_payroll_integration_status.unavailable')
      }
      case 'available': {
        return i18n.t('bookkeepers.incidence.incidence_payroll_integration_status.available')
      }
      case 'done': {
        return i18n.t('bookkeepers.incidence.incidence_payroll_integration_status.done')
      }
    }

    return i18n.t('bookkeepers.incidence.incidence_payroll_integration_status.undefined')
  }

  return (
    <>
      {showIncidencePayrollIntegrationStatus && (
        <Table.Cell>
          <Box maxWidth={isBookkeeperView ? 's140' : undefined}>
            <Box alignItems="flexStart">
              <Tag type={payrollIntegrationStatusTagColor(payrollIntegrationStatus)}>
                <Text.Normal weight="normal" color="grey1000" size="200" whiteSpace="nowrap">
                  {payrollIntegrationStatusTranlsation()}
                </Text.Normal>
              </Tag>
            </Box>
          </Box>
        </Table.Cell>
      )}
    </>
  )
}

export default observer(PayrollIntegrationStatus)
